/**
 * localDay.js - a Date as its LOCAL calendar day, 'YYYY-MM-DD' (what the
 * person's own calendar says; toISOString's UTC day is tomorrow after about
 * 8pm Eastern). The one copy the screens share.
 */
const pad = (n) => String(n).padStart(2, '0');

/** @param {Date} [d] */
export const localDay = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
